export const messages = {
  NOT_AVAILABLE: 'N/A',
};
